import script from "./CaseBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseBox.vue?vue&type=script&setup=true&lang=js"

import "./CaseBox.vue?vue&type=style&index=0&id=cf2b0118&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf2b0118"]])

export default __exports__